
import { useEffect } from 'react';
import './App.css';
import Articolo from './Components/Articolo';
import Sezione from './Components/Sezione';
import Principal from './Principal';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { getConsent } from './Components/Cookie/cookieUtils';
import { loadGoogleAnalytics } from './Components/Cookie/analyticsUtils';
import RouteTracker from './RouteTracker';
import AdminLogin from './ComponentsAdmin/AdminLogin';

//Importazione dei componenti di routing da "react-router-dom"
//BrowserRouter: (Rinominato come Router): Gestisce la storia della navigazione e avvolge
//  tutta l'app.
//Routes: Contiene una lista di percorsi definiti
//Route: Definisce un singolo percorso e specifica quale componente deve essere mostrato

//La funzione "App" definisce l'intera struttura e logica di navigazione dell'app.

//<Router>
//Avvolge tutti i percorsi e abilita la navigazione all'interno dell'app

//<Routes>
//Contiene tutti i percorsi (<Route>) definiti per l'app.

//<Route>
//path="/"
//Questo è il percorso principale (root). Quando l'utente visita l'URL base
//verrà mostrato il componente <Principal/>, che rappresenta la home page.

//path="/sezione/:id"
//Questo percorso mostra il componente "<Sezione/>"
//Il parametro ":id" è dinamico e consente di identificare una specifica sezione. Ad esempio:
//"http://localhost:3000/sezione/1" mostrerà la sezione con ID 1.
//Il valore di "id" verrà passato al componente "Sezione" tramite i parametri della route

//path="/sottosezione/:id"
//Questo percorso funziona come quello della sezione, ma si riferisce a una sottosezione.
//Ad esempio, "http://localhost:3000/sottosezione/5" mostrerà la sottosezione con ID 5.

//path="/articolo/:id"
//Mostra il componente <Articolo/>, visualizzando un singolo articolo identificato da un ID dinamico.
//Ad esempio, http://localhost:3000/articolo/42 mostrerà l'articolo con ID 42

//element:
//Specifica quale componente deve essere renderizzato per quel particolare percorso.
function App() {

    useEffect(()=>{
        const consent =getConsent();
        if(consent?.analytics){
            loadGoogleAnalytics("G-9F3W0CZEKC")
        }
    },[]);

  return (
      <Router>
      <RouteTracker/>
          <Routes>
              <Route path="/" element={<Principal />} />
              <Route path="/sezione/:slug" element={<Sezione />} />
              <Route path="/articolo/:slug" element={<Articolo />} />
              <Route path='admin' element={<AdminLogin />} />
          </Routes>
      </Router>
  );
}

export default App;